var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoneyEnvelopeBlue = function SvgMoneyEnvelopeBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "money-envelope--blue_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".money-envelope--blue_svg__st0{fill:#0b1b34}.money-envelope--blue_svg__st1{fill:#fff}.money-envelope--blue_svg__st2{fill:#0185ff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4 56C20 56 14 50 14 42.6V38c0-7.4 6-13.4 13.4-13.4V56z",
    className: "money-envelope--blue_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 56.8h-.8c-7.8 0-14.2-6.3-14.2-14.2V38c0-7.8 6.3-14.2 14.2-14.2h.8v33zm-1.6-31.3c-6.6.4-11.8 5.8-11.8 12.5v4.6c0 6.6 5.2 12.1 11.8 12.5V25.5z",
    className: "money-envelope--blue_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6 52.4H54v-24H7.6v24z",
    className: "money-envelope--blue_svg__st2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1 53.1H7.7c-.5 0-.8-.3-.8-.8v-24c0-.5.3-.8.8-.8h46.4c.5 0 .8.3.8.8v24c0 .5-.4.8-.8.8zM8.5 51.5h44.8V29.1H8.5v22.4z",
    className: "money-envelope--blue_svg__st1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4 49.1c0-1.8 1.4-3.2 3.2-3.2V34.7c-1.8 0-3.2-1.4-3.2-3.2H14.9c0 1.8-1.4 3.2-3.2 3.2v11.2c1.8 0 3.2 1.4 3.2 3.2h32.5z",
    className: "money-envelope--blue_svg__st2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4 49.9H14.1v-.8c0-1.4-1-2.4-2.4-2.4h-.8V33.9h.8c1.4 0 2.4-1 2.4-2.4v-.8h34.2v.8c0 1.3 1 2.4 2.4 2.4h.8v12.8h-.8c-1.4 0-2.4 1-2.4 2.4v.8h-.9zm-31.8-1.6h31.1c.3-1.6 1.5-2.8 3.1-3.1v-9.8c-1.6-.3-2.8-1.5-3.1-3.1H15.6c-.3 1.5-1.5 2.8-3.1 3.1v9.8c1.5.3 2.8 1.6 3.1 3.1z",
    className: "money-envelope--blue_svg__st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9 45.5c2.7 0 4.8-2.1 4.8-4.8 0-2.7-2.1-4.8-4.8-4.8-2.7 0-4.8 2.1-4.8 4.8 0 2.7 2.1 4.8 4.8 4.8z",
    className: "money-envelope--blue_svg__st2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9 46.3c-3.1 0-5.6-2.6-5.6-5.6 0-3.1 2.6-5.6 5.6-5.6s5.6 2.6 5.6 5.6c.1 3.1-2.5 5.6-5.6 5.6zm0-9.7c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4z",
    className: "money-envelope--blue_svg__st1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4 24.7 33 40.3 27.4 56H72V24.7H27.4z",
    className: "money-envelope--blue_svg__st0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8 56.8H26.3l5.8-16.5-5.8-16.4h46.5v32.9zm-44.2-1.6h42.6V25.5H28.6l5.3 14.8-5.3 14.9z",
    className: "money-envelope--blue_svg__st1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m71.8 56.2-6.5-6.5c-.2-.2-.2-.3-.2-.6V30.8c0-.2.1-.4.2-.6l6.1-6.1 1.1 1.1-5.8 5.8v17.7l6.2 6.2-1.1 1.3z",
    className: "money-envelope--blue_svg__st1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9 39.5H33v1.6h32.9v-1.6z",
    className: "money-envelope--blue_svg__st1"
  })));
};
export default SvgMoneyEnvelopeBlue;